import { Box, Divider, FormControlLabel, Grid, styled } from '@mui/material';

export const StyleDivider = styled(Divider)(
  ({ theme }) => `
  margin-top:8px;
    border-bottom: 1px solid ${theme.palette.brand.black};
  `,
);

export const InputContainer = styled(Box)(
  ({ theme }) => `
  width: 474px;
  margin-top: 24px;
  & input {
    background: ${theme.palette.secondary.lighter};
    border: 0;
  }
`,
);

export const ProductContainer = styled(Box)`
  margin-top: 20px;
`;

export const ProductCategorySectionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const ProductGridContainer = styled(Grid)`
  margin: 5px 0;
  height: 50vh;
  overflow-y: scroll;
  align-content: flex-start;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding-bottom: 15px;
  position: fixed;
  bottom: 5px;
  right: 20px;
  background-color: #fff;
`;

export const CheckboxLabel = styled(FormControlLabel)`
  font-size: 16px;
  weight: 300;
  font-family: 'Roboto';
  .MuiFormControlLabel-label {
    word-break: break-word;
    white-space: normal;
  }
`;

export const StyledHeader = styled('div')`
  padding-bottom: 32px;
`;

export const StyledGrid = styled(Grid)`
  padding-top: 0 !important;
`;
